import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../estilos/Todas_las_Experiencia.css";
import Navega from "../componentes/Nav";
import { getTours } from "../api/tours";
import { useTranslation } from "react-i18next";
import { useSeo } from "../seo";
import { ruta } from "../rutas";

const ITEMS_PER_PAGE = 6;

function Todas_las_experiencia() {
  const [tours, setTours] = useState([]);
  const [page, setPage] = useState(1);
  const { t, i18n } = useTranslation();
  const esIngles = i18n.language === 'en';

  useSeo({ pagina: 'todas' });

  useEffect(() => {
    getTours().then(data => setTours(data));
  }, []);

  const start = (page - 1) * ITEMS_PER_PAGE;
  const currentItems = tours.slice(start, start + ITEMS_PER_PAGE);
  const totalPages = Math.ceil(tours.length / ITEMS_PER_PAGE);

  return (
    <>
      <Navega />

      <section className="experiencias">

        <div className="experiencias-header">
          <span className="eyebrow">
            {esIngles ? 'Discover · Explore · Live' : 'Descubre · Explora · Vive'}
          </span>
          <h1>{t('todas_titulo')}</h1>
          <p className="subtitle">{t('todas_subtitulo')}</p>
        </div>

        <div className="grid">
          {currentItems.map((item) => (
            <Link
              key={item.slug}
              to={ruta('detalle', esIngles ? 'en' : 'es', { slug: item.slug })}
              className="card"
            >
              <img src={item.image} alt={esIngles ? item.title_en : item.title} />
              <div className="card-overlay">
                <span>{esIngles ? item.category_en : item.category}</span>
                <h3>{esIngles ? item.title_en : item.title}</h3>
                <span className="card-arrow">
                  {esIngles ? 'View experience' : 'Ver experiencia'}
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="pagination">
          {Array.from({ length: totalPages }).map((_, i) => (
            <button
              key={i}
              className={page === i + 1 ? "active" : ""}
              onClick={() => { setPage(i + 1); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
            >
              {i + 1}
            </button>
          ))}
        </div>

      </section>
    </>
  );
}

export default Todas_las_experiencia;